import React from 'react'
// Components
import _Picker, { Props as _PickerProps } from './_Picker'

const DatePicker: React.FC<Omit<_PickerProps, 'picker'>> = (p) => (
  <_Picker {...p} picker={'date'} />
)

export default DatePicker
